import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

/**
 * Store for managing branch, session, group data for view as learner.
 *
 * @type {FluxibleStore}
 */
class ChangeViewSettingsModalStore extends BaseStore {
  static storeName = 'ChangeViewSettingsModalStore';

  initialize() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'branchesSessionsGroups' does not exist o... Remove this comment to see the full error message
    this.branchesSessionsGroups = [];
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'groups' does not exist on type 'ChangeVi... Remove this comment to see the full error message
    this.groups = [];
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sessions' does not exist on type 'Change... Remove this comment to see the full error message
    this.sessions = [];
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedBranchId' does not exist on type... Remove this comment to see the full error message
    this.selectedBranchId = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedGroupId' does not exist on type ... Remove this comment to see the full error message
    this.selectedGroupId = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSessionId' does not exist on typ... Remove this comment to see the full error message
    this.selectedSessionId = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedContextId' does not exist on typ... Remove this comment to see the full error message
    this.selectedContextId = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loaded' does not exist on type 'ChangeVi... Remove this comment to see the full error message
    this.loaded = false;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'emptyGroup' does not exist on type 'Chan... Remove this comment to see the full error message
    this.emptyGroup = { id: null, isEmptyGroup: true, name: 'No group selected', isArchived: false };
  }

  getGroups() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'groups' does not exist on type 'ChangeVi... Remove this comment to see the full error message
    return this.groups;
  }

  getSessions() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sessions' does not exist on type 'Change... Remove this comment to see the full error message
    return this.sessions;
  }

  getBranches() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'branchesSessionsGroups' does not exist o... Remove this comment to see the full error message
    return this.branchesSessionsGroups;
  }

  getSelectedSessionId() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSessionId' does not exist on typ... Remove this comment to see the full error message
    return this.selectedSessionId;
  }

  getSelectedBranchId() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedBranchId' does not exist on type... Remove this comment to see the full error message
    return this.selectedBranchId;
  }

  getSelectedGroupId() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedGroupId' does not exist on type ... Remove this comment to see the full error message
    return this.selectedGroupId;
  }

  getSelectedContextId() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedContextId' does not exist on typ... Remove this comment to see the full error message
    return this.selectedContextId;
  }

  hasLoaded() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loaded' does not exist on type 'ChangeVi... Remove this comment to see the full error message
    return this.loaded;
  }

  refreshGroups() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSessionId' does not exist on typ... Remove this comment to see the full error message
    if (this.selectedSessionId) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sessions' does not exist on type 'Change... Remove this comment to see the full error message
      const selectedSession = this.sessions.find((session) => session.id === this.selectedSessionId);

      if (selectedSession) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'groups' does not exist on type 'ChangeVi... Remove this comment to see the full error message
        this.groups = selectedSession.groups.filter((group) => group.isArchived === false);
      } else {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'groups' does not exist on type 'ChangeVi... Remove this comment to see the full error message
        this.groups = [];
      }
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'groups' does not exist on type 'ChangeVi... Remove this comment to see the full error message
      this.groups = [];
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedGroupId' does not exist on type ... Remove this comment to see the full error message
    this.selectedGroupId = null;
  }

  static handlers = {
    RECEIVE_BRANCHES_SESSIONS_GROUPS_FOR_COURSE({ branchesSessionsGroups, excludeEmptyGroup = false }: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'branchesSessionsGroups' does not exist o... Remove this comment to see the full error message
      this.branchesSessionsGroups = branchesSessionsGroups;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'branchesSessionsGroups' does not exist o... Remove this comment to see the full error message
      this.branchesSessionsGroups.forEach((branch) => {
        branch.associatedSessionsList.forEach((session: $TSFixMe) => {
          if (!excludeEmptyGroup && session.groups.length > 0) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'emptyGroup' does not exist on type '{ RE... Remove this comment to see the full error message
            session.groups.unshift(this.emptyGroup);
          }
        });
        return branch;
      });
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loaded' does not exist on type '{ RECEIV... Remove this comment to see the full error message
      this.loaded = true;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ RE... Remove this comment to see the full error message
      this.emitChange();
    },
    RECEIVE_BRANCH_SELECTION(selectedBranchId: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedBranchId' does not exist on type... Remove this comment to see the full error message
      this.selectedBranchId = selectedBranchId;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sessions' does not exist on type '{ RECE... Remove this comment to see the full error message
      this.sessions = this.branchesSessionsGroups.find(
        (branch: $TSFixMe) => branch.id === selectedBranchId
      ).associatedSessionsList;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSessionId' does not exist on typ... Remove this comment to see the full error message
      this.selectedSessionId = this.sessions.length > 0 ? this.sessions[0].id : null;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'refreshGroups' does not exist on type '{... Remove this comment to see the full error message
      this.refreshGroups();

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ RE... Remove this comment to see the full error message
      this.emitChange();
    },
    RECEIVE_SESSION_SELECTION(selectedSessionId: $TSFixMe) {
      if (selectedSessionId) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSessionId' does not exist on typ... Remove this comment to see the full error message
        this.selectedSessionId = selectedSessionId;
      } else {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSessionId' does not exist on typ... Remove this comment to see the full error message
        this.selectedSessionId = this.sessions.length > 0 ? this.sessions[0].id : null;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'refreshGroups' does not exist on type '{... Remove this comment to see the full error message
      this.refreshGroups();

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ RE... Remove this comment to see the full error message
      this.emitChange();
    },
    RECEIVE_GROUP_SELECTION(selectedGroupId: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedGroupId' does not exist on type ... Remove this comment to see the full error message
      this.selectedGroupId = selectedGroupId;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ RE... Remove this comment to see the full error message
      this.emitChange();
    },
    RECEIVE_CONTEXT_SELECTION(selectedContextId: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedContextId' does not exist on typ... Remove this comment to see the full error message
      this.selectedContextId = selectedContextId;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ RE... Remove this comment to see the full error message
      this.emitChange();
    },
  };
}

export default ChangeViewSettingsModalStore;
